import { ICustomerAddress } from "../models/ICustomerAddress";
import { configWithUserToken } from "./config";

export interface IAddressBody {
  customerAddressDescription: string;
  customerAddressNote: string;
  customerAddressIsDefault: boolean;
  customerAddressLatitude: number;
  customerAddressLongitude: number;
  cityId: string;
  townId: string;
}

export const getCustomerAddressList = (customerId: string) => {
  return configWithUserToken.get<ICustomerAddress[]>(
    `CustomerAddress/CustomerAddressList/${customerId}`
  );
};

export const addCustomerAddress = (customerId: string, body: IAddressBody) => {
  return configWithUserToken.post(`CustomerAddress/${customerId}`, body);
};

export const updateCustomerAddress = (addressId: string, body: IAddressBody) => {
  return configWithUserToken.put(`CustomerAddress/${addressId}`, body);
};

export const deleteCustomerAddress = (customerId: string, addressId: string) => {
  return configWithUserToken.delete(`CustomerAddress/${customerId}/${addressId}`);
};
